import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import isEmpty from 'lodash/isEmpty'

import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'
import LastOrdersContainer from '../../containers/InsightsSectionLastOrdersContainer'

import CustomCard from './CustomCard'
import ClientData from './ClientData'
import LastCart from './LastCart'
import MostPuchased from './MostPuchased'

const Index = ({ customer, router, addCustomerLastCartItems, orderForm }) => {
  const { profile } = customer
  const { customerCustomCard } = getInstoreConfig()

  return (
    <div className="flex-l flex-row-l w-100">
      <div className="w-50-l">
        <div className="pr6-l mb7 mb8-l">
          <ClientData profile={profile} orderForm={orderForm} />
        </div>

        {!isEmpty(customerCustomCard) && (
          <div className="pr6-l mb7 mb8-l">
            <CustomCard {...customerCustomCard} />
          </div>
        )}

        <div className="pr6-l mb7 mb8-l">
          <LastCart
            profile={profile}
            addLastCartProductsToCart={addCustomerLastCartItems}
            router={router}
          />
        </div>

        {profile.productPurchasedTag && (
          <div className="pr6-l mb7 mb8-l">
            <MostPuchased profile={profile} router={router} />
          </div>
        )}
      </div>
      <div className="w-50-l pl6-l mb7 mb8-l">
        <LastOrdersContainer />
      </div>
    </div>
  )
}

Index.propTypes = {
  router: PropTypes.any,
  customer: PropTypes.object.isRequired,
  orderForm: PropTypes.object.isRequired,
  addCustomerLastCartItems: PropTypes.func.isRequired,
  openCart: PropTypes.object,
}

export default withRouter(Index)
